/**
 *
 * TermsOfUse
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { createStructuredSelector } from 'reselect';
import Grid from '@material-ui/core/Grid';
import { compose } from 'redux';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import AppContainer from 'components/AppContainer';
import _isEmpty from 'lodash/isEmpty';
import {
  makeSelectShowingPrivacyPolicy,
  makeSelectPrivacyPolicy,
} from 'containers/Main/selectors';
import { showPrivacyPolicy } from 'containers/Main/actions';
import DialogTransition from 'components/DialogTransition';

const styles = () => ({
  topClose: {
    position: 'absolute',
    top: 0,
    right: 5,
    zIndex: 10,
    cursor: 'pointer',
  },
  bottomClose: {
    zIndex: 10,
    cursor: 'pointer',
  },
  closeIcon: {
    fontSize: 30,
  },
});

/* eslint-disable react/prefer-stateless-function */
export class PrivacyPolicy extends React.PureComponent {
  handleClose = () => {
    this.props.showPrivacyPolicy(false);
  };

  getCloseButton = isBottom => {
    const { classes } = this.props;
    return (
      <IconButton
        color="inherit"
        onClick={this.handleClose}
        aria-label="Close"
        className={isBottom ? classes.bottomClose : classes.topClose}
      >
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
    );
  };

  render() {
    const { data, showingPrivacyPolicy } = this.props;
    return (
      <Dialog
        fullScreen
        open={showingPrivacyPolicy}
        onClose={this.handleClose}
        TransitionComponent={DialogTransition}
      >
        {this.getCloseButton()}
        {!_isEmpty(data) && (
          <AppContainer>
            <Grid item xs={12}>
              <Typography variant="h6">{data.pageHeader}</Typography>
            </Grid>
            <Grid item xs={12}>
              <RichTextReactRenderer data={data.body.json} />
            </Grid>
            <Grid item xs={12} container justify="center">
              {this.getCloseButton(true)}
            </Grid>
          </AppContainer>
        )}
      </Dialog>
    );
  }
}

PrivacyPolicy.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  showingPrivacyPolicy: PropTypes.bool,
  showPrivacyPolicy: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  data: makeSelectPrivacyPolicy(),
  showingPrivacyPolicy: makeSelectShowingPrivacyPolicy(),
});

function mapDispatchToProps(dispatch) {
  return {
    showPrivacyPolicy: payload => dispatch(showPrivacyPolicy(payload)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withStyles(styles),
  withConnect,
)(PrivacyPolicy);
